// anúncio em revisão ou rejeitado não veiculou: métrica vira traço
export const toggleValueByStatus = (
  status: string,
  // o valor vai direto para o `render` da coluna, que aceita string, número ou
  // elemento — tipar aqui empurraria um cast para cada chamada
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
) => (['pending_review', 'rejected'].includes(status) ? '-' : value)

// inclui a coluna só quando a métrica está disponível na resposta
export const pickColumn = <T>(
  enabled: boolean | undefined,
  key: string,
  columns: Record<string, T>
) => (enabled ? { [key]: columns[key] } : {})
